import { text_colorTextSecondary } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_semibold,
  font_size_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

/**
 * Section kicker shared by the card-detail Statements and Activity tabs
 * (EX-40600) — the small uppercase label the card-management design puts above
 * each tab's list. Shared because both tabs render the identical element from
 * the same design spec; it lives here rather than in either tab so neither owns
 * the other's styling.
 *
 * Uppercased via CSS, never in the translation source, so the accessible name
 * stays the plain tab word.
 */
export const cardDetailTabSectionTitle = css`
  font-size: ${font_size_sm};
  font-family: ${font_family_weight_semibold};
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${text_colorTextSecondary};
  margin: 0 0 ${spacing(4)};
`

/**
 * The row that pairs the kicker above with a trailing badge, shared by the
 * Statements and Activity tabs.
 *
 * It lives HERE, next to the title, because it exists only to neutralise that
 * title's own `margin-bottom`: in a flex row `align-items: center` centres
 * MARGIN boxes, so the bottom margin would lift the heading's text half its
 * height above the badge beside it. The row takes the spacing over and zeroes it
 * on the heading, which keeps the gap below the row identical while letting the
 * two actually centre on each other.
 *
 * Because the two rules are a matched pair, splitting them across per-tab style
 * files means anyone adjusting the kicker's margin has to find every private
 * copy of the compensation. Keeping them adjacent is what makes that impossible
 * to miss.
 */
export const cardDetailTabSectionHeading = css`
  display: flex;
  align-items: center;
  gap: ${spacing(2)};
  margin-bottom: ${spacing(4)};

  > h2 {
    margin-bottom: 0;
  }
`
